import { UserCardFragmentFragment } from '@/__generated__/graphql';
import { useUsersTypeahead } from '@/components/users/use-users-typeahead';
import { UsersMultiSelectComboboxBase } from './users-multi-select-combobox-base';

export const UsersMultiSelectCombobox = ({
  wrapperClassName,
  selectedUsers,
  setSelectedUsers,
  error,
  setError,
}: {
  wrapperClassName?: string;
  selectedUsers: UserCardFragmentFragment[];
  setSelectedUsers: (users: UserCardFragmentFragment[]) => void;
  error?: string;
  setError?: (error?: string) => void;
}) => {
  const { users, onValueChange, isLoading } = useUsersTypeahead();

  return (
    <UsersMultiSelectComboboxBase
      wrapperClassName={wrapperClassName}
      selectedUsers={selectedUsers}
      setSelectedUsers={setSelectedUsers}
      error={error}
      setError={setError}
      users={users}
      onInputChange={onValueChange}
      isLoading={isLoading}
    />
  );
};
